import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './AdminHeader.css';

const AdminHeader = ({ toggleSidebar, onLogout }) => {
  const [adminUser, setAdminUser] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const user = localStorage.getItem('adminUser');
    if (user && user !== 'undefined' && user !== 'null') {
      try {
        setAdminUser(JSON.parse(user));
      } catch (error) {
        console.error('Failed to parse admin user data:', error);
        localStorage.removeItem('adminUser');
      }
    }
  }, []);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  return (
    <header className="admin-header">
      <div className="admin-header-left">
        <button className="sidebar-toggle" onClick={toggleSidebar}>
          <i className="fas fa-bars"></i>
        </button>
        <h1 className="admin-page-title">Admin Dashboard</h1>
      </div>

      <div className="admin-header-right">
        <button className="admin-header-btn">
          <i className="fas fa-bell"></i>
          <span className="notification-badge">3</span>
        </button>

        <div className="admin-user-menu">
          <button className="admin-user-btn" onClick={toggleDropdown}>
            <div className="admin-user-avatar">
              {adminUser?.first_name?.[0] || 'A'}
            </div>
            <div className="admin-user-info">
              <span className="admin-user-name">
                {adminUser?.first_name} {adminUser?.last_name}
              </span>
              <span className="admin-user-role">{adminUser?.role}</span>
            </div>
            <i className="fas fa-chevron-down"></i>
          </button>

          {dropdownOpen && (
            <div className="admin-dropdown">
              <Link to="/admin/profile" className="admin-dropdown-item">
                <i className="fas fa-user"></i>
                Profile
              </Link>
              <Link to="/admin/settings" className="admin-dropdown-item">
                <i className="fas fa-cog"></i>
                Settings
              </Link>
              <div className="admin-dropdown-divider"></div>
              <button onClick={onLogout} className="admin-dropdown-item">
                <i className="fas fa-sign-out-alt"></i>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

export default AdminHeader;

